import { ref, computed } from 'vue'
import localService from '&/services/localService.js'
import languageService from '&/services/languageService'

// Estado global reactivo para idioma
const language = ref(null)

/**
 * Composable para manejar el idioma global de la aplicación
 */
export function useLanguage() {
  return {
    // Estado reactivo
    language: computed({
      get() {
        if (!language.value) {
          language.value = localService.getSelectedLanguage()
        }
        return language.value
      },
      set(newLanguage) {
        localService.setSelectedLanguage(newLanguage)
        language.value = newLanguage
      }
    }),

    getAvailableLanguages: () => {
      return languageService.getActiveLanguages()
    }
  }
}
